export default [
  {
    label: '基本信息',
    children: [
      {
        label: '合同编号'
      },
      {
        label: '合同名称'
      },
      {
        label: '所属公司'
      },
      {
        label: '甲方统一社会信用代码'
      },
      {
        label: '甲方委托代理人/联系电话'
      },
      {
        label: '甲方法定代表人'
      },
      {
        label: '甲方联系人/联系地址/邮编'
      },
      {
        label: '乙方统一社会信用代码'
      },
      {
        label: '乙方法定代表人'
      },
      {
        label: '乙方委托代理人/联系电话'
      },
      {
        label: '乙方联系人/联系地址/邮编'
      },
    ]
  },
  {
    label: '租赁房屋信息',
    children: [
      {
        label: '产权证号'
      },
      {
        label: '租赁地址1'
      },
      {
        label: '租赁地址2'
      },
      {
        label: '建筑面积'
      },
      {
        label: '租赁面积'
      },
      {
        label: '甲方'
      },
      {
        label: '乙方'
      },
      {
        label: '备注'
      }
    ]
  },
  {
    label: '租赁期限和交付日期',
    children: [
      {
        label: '合同期限'
      },
      {
        label: '合同起始日期'
      },
      {
        label: '合同结束日期'
      },
      {
        label: '房屋交付日期'
      }
    ]
  },
  {
    label: '免租期、支付周期、保证金',
    children: [
      {
        label: '日租金'
      },
      {
        label: '免租期',
        mark: '1'
      },
      {
        label: '免租期起始日期',
        mark: '1'
      },
      {
        label: '免租期结束日期',
        mark: '1'
      },
      {
        label: '租金起算日期'
      },
      {
        label: '租金支付周期'
      },
      {
        label: '保证金'
      }
    ]
  },
  {
    label: '乙方首期交金',
    children: [
      {
        label: '首期房屋租金'
      },
      {
        label: '首期房屋租金起始时间'
      },
      {
        label: '首期房屋租金结束时间'
      },
      {
        label: '首期物业管理费',
        mark: '1'
      },
      {
        label: '首期物业管理费开始日期',
        mark: '1'
      },
      {
        label: '首期物业管理费结束日期',
        mark: '1'
      },
      {
        label: '首期房租租金和物业管理费合计',
        mark: '1'
      },
      {
        label: '首期保证金、房租租金、物业管理费合计',
        mark: '1'
      }
    ]
  },
  {
    label: '收款账户',
    children: [
      {
        label: '甲方公司名称'
      },
      {
        label: '银行账户'
      },
      {
        label: '银行账号'
      }
    ]
  },
  {
    label: '租金价目表',
    children: [
      {
        label: '项目',
        mark: '1'
      },
      {
        label: '租赁期起始日期',
        mark: '1'
      },
      {
        label: '租赁期结束日期',
        mark: '1'
      },
      {
        label: '每期租金',
        mark: '1'
      },
      {
        label: '租金总额',
        mark: '1'
      },
      {
        label: '日租金',
        mark: '1'
      },
      {
        label: '物业管理费',
        mark: '1'
      },
      {
        label: '备注',
        mark: '1'
      }
    ]
  }
]
